import React from 'react';
import HomePage from './pages/HomePage';
import WhatIsGoloka from './pages/WhatIsGoloka';
import HowToReach from './pages/HowToReach';
import Quizzes from './pages/Quizzes';
import Calendar from './pages/Calendar';
import './MainContent.css';

function MainContent({ activePage, sidebarCollapsed, setActivePage }) {
    const renderContent = () => {
        switch (activePage) {
            case 'home':
                return <HomePage setActivePage={setActivePage} />;
            case 'what-is-goloka':
                return <WhatIsGoloka />;
            case 'how-to-reach':
                return <HowToReach />;
            case 'quizzes':
                return <Quizzes />;
            case 'calendar':
                return <Calendar />;
            default:
                return <HomePage setActivePage={setActivePage} />;
        }
    };

    return (
        <div className={`main-content ${sidebarCollapsed ? 'expanded' : ''}`}>
            <div className="content-wrapper">
                {renderContent()}
            </div>
        </div>
    );
}

export default MainContent;
